let totalTimeOnPageSeconds = 0
let thisVisibleSessionStartSeconds = 0
let eventHandlerCreated = false

/**
 * This module allows tracking of how long the page has been in the "visible" state.
 * This is just a rough proxy for the user's active time on the page as it doesn't
 * track if the user is actually actively engaging.
 *
 * Eg. A user could open a page, then wander off to the coffee machine for five
 * minutes with the page left open. This implementation would count that as
 * five minutes "active time", despite the user not actually being active.
 *
 * However for an initial version this seems good enough, and potentially
 * more accurate than the existing GA4 "active time" analytics. We can
 * revisit and produce a more accurate version in the future if required.
 */

export function initialiseActiveTimeOnPage() {
  totalTimeOnPageSeconds = 0
  thisVisibleSessionStartSeconds = 0
  if (document.visibilityState === "visible") {
    startTrackingActiveTimeOnPage()
  }

  if (eventHandlerCreated) {
    return
  }

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      stopTrackingActiveTimeOnPage()
    } else {
      startTrackingActiveTimeOnPage()
    }
  })
  eventHandlerCreated = true
}

function startTrackingActiveTimeOnPage() {
  thisVisibleSessionStartSeconds = Math.floor(Date.now() / 1000)
}

function stopTrackingActiveTimeOnPage() {
  const timeNow = Math.floor(Date.now() / 1000)
  if (thisVisibleSessionStartSeconds > 0) {
    const elapsedSeconds = timeNow - thisVisibleSessionStartSeconds
    totalTimeOnPageSeconds = totalTimeOnPageSeconds + elapsedSeconds
  }

  thisVisibleSessionStartSeconds = 0
}

export function getCurrentActiveTimeOnPage() {
  if (thisVisibleSessionStartSeconds == 0) {
    return totalTimeOnPageSeconds
  }

  if (document.visibilityState === "hidden") {
    return totalTimeOnPageSeconds
  }

  const elapsedSeconds = Math.floor(Date.now() / 1000) - thisVisibleSessionStartSeconds
  return totalTimeOnPageSeconds + elapsedSeconds
}
